import type { FaireProductEntity } from "../../entity_types/product";

export const p_w8bw546pc7: FaireProductEntity = {
  token: "p_w8bw546pc7",
  type: "product",
  name: "Love Rainbow Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/771ea02608046ad6275a3ba4996fa382a5d580e0bd25bc5be4a28d94897f8962.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a619c9935109d1bb7a78dd5b4caf5c039eb79cb2d199a96a13a89d3c7c7616fc.jpeg",
    "https://cdn.faire.com/fastly/4dc8228d3dbc82418c28c671596d14a4eab30f46ebb0f5d0f6b9978c36025c93.jpeg",
    "https://cdn.faire.com/fastly/60880c85f64f9079623f38b76fc6d76b354b4d21f1ac48afcebec3cc8694fe44.jpeg",
    "https://cdn.faire.com/fastly/7b862c506563ad2120005da4de6e5da48dcca16476b9b69d58521b580bae1369.png",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:08.103Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
